'use client';

import type { ReactNode } from 'react';

interface GardenViewProps {
  summary: ReactNode;
  grid: ReactNode;
}

export function GardenView({ summary, grid }: GardenViewProps) {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col pt-4">
      <div className="shrink-0 px-4 pb-2">{summary}</div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 py-4">{grid}</div>
    </div>
  );
}
